
        Component.define('template-footer', (el, params) => {
            /**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

// const $el             = $(el);

        });